import { Box } from "@chakra-ui/react";
import { NumericFormat } from "react-number-format";

import { Input, Text } from "@equidefi/ui";

export function USDInput({ values, errors, touched, handleBlur, setValues, unitPrice }) {
  const displayAmount =
    values.amount !== 0 && values.amount !== "" && values.amount !== null && values.amount !== undefined
      ? values.amount
      : "";

  return (
    <Box mb={2} w="full">
      <Text mb="2" fontWeight="medium">
        Enter the amount you want to invest.
      </Text>
      <Input
        maxW="100%"
        isInvalid={errors.amount && touched.amount}
        as={NumericFormat}
        name="amount"
        allowNegative={false}
        thousandSeparator
        prefix="$"
        value={displayAmount}
        placeholder="$0"
        onBlur={handleBlur}
        onValueChange={({ value }) => {
          const parsed = Number(value);
          const numValue = value === "" || isNaN(parsed) ? 0 : parsed;
          setValues((current) => ({
            ...current,
            amount: numValue,
            quantity: unitPrice > 0 ? numValue / unitPrice : 0,
          }));
        }}
        decimalScale={2}
        fixedDecimalScale={false}
        error={errors.amount}
      />
    </Box>
  );
}
